import type { ComponentType } from "react";

import type { RenderFunc } from "./ErrorBoundary";
import { ErrorBoundary } from "./ErrorBoundary";

export const withErrorBoundary = <Props extends object = object>(
  WrappedComponent: ComponentType<Props>,
  renderFunc: RenderFunc,
  options: { handleNotFoundError?: boolean; shouldAutoReload?: boolean } = {
    handleNotFoundError: false,
  },
) => {
  const component = (props: Props) => (
    <ErrorBoundary
      renderFunc={renderFunc}
      handleNotFoundError={options.handleNotFoundError}
      shouldAutoReload={options.shouldAutoReload}
    >
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  component.displayName = `withErrorBoundary(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return component;
};
